import React from "react";
import './search-filter-date.css';
import { DatePicker } from "antd";

const SearchFilterDate = ({...props}) => {
    const {title, value, onChange, disabledDate, format} = props;

    return<div className="search-filter-date">
        <div className="search-filter-date-title">{title}</div>
        <div className="search-filter-date-control">
            <img src="/images/calendar16.svg" alt="" />
            <DatePicker 
                format={format || 'DD.MM.YYYY'}
                allowClear={false} 
                bordered={false}
                suffixIcon={null}
                className="search-filter-date-input"
                value={value}
                onChange={onChange}
                disabledDate={disabledDate}
            />
        </div>
    </div>
}

export default SearchFilterDate;